<template>
    <div class="header courseSearch " :class="{'courseSearchPC':$store.state.innerWidth>768,'showExtraHeight':showExtra}">
        <div class="warp-mask"></div>
        <div class="course-container col-sm-10 col-md-8 padLeft-0 padRight-0" style="width: 1280px !important;">
            <h1 class="course-contant Bold">{{$t('message.Browse Courses')}}</h1>
            <div class="search-criteria-w">
                <div class="row search-criteria">
                    <div class="col-sm-8 col-lg-9">
                        <div class="row">
                            <div class="col-sm-6 pad-10 ">
                                <div class="input-group">
                                    <b class="i-left">
                                        <i class="icon-search gray" aria-hidden="true"></i>
                                    </b>
                                    <input 
																			maxlength='200'
																			type="text"
																			@keydown.enter="searchEvent" 
																			v-model="keyword" 
																			v-bind:placeholder="$t('message.CourseInputTip')" 
																			class="input-two" 
																			autocomplete="off"
																			:aria-label="$t('message.CourseInputTip')"
																		/>
                                    <b class="i-right" v-if="keyword" @click="clearEvent">
                                        <i class="icon-close-1 gray" aria-hidden="true"></i>
                                    </b>
                                </div>
                            </div>
                            <div class="col-sm-6 pad-10 " :class="{'show':showAreaOfStudy}">
                                <div class="input-group" @click="openAreaOfStudy" role="combobox" :aria-label="$t('message.All Areas of Study')">
                                    <b class="i-left">
                                      <i class="icon-icon-svg-11 gray" aria-hidden="true"></i>
                                    </b>
                                    <div class="input-two allInput">
                                      <span  class="oneline-box"  v-if="!areaOfStudyDisplay" >
																				<a href="javascript:;" style="color: inherit">{{$t('message.All Areas of Study')}}</a>
																			</span>
                                      <span  class="oneline-box" v-else >
																				<a href="javascript:;" style="color: inherit">{{areaOfStudyDisplay}}</a>
																			</span>
                                    </div>
                                    <b class="i-right">
                                      <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                                    </b>
                                </div>
                                <div class="criteria-content multi-layer criteria-job-func show-choice "  ref="hexagonInner"  :class="{'show':showAreaOfStudy}">
                                    <ul ref="hexagonUl">
                                        <li class="item-table" ref="hexagonOneLi" v-on:click="selectAllAreaOfStudyFn()" role="option" :aria-label="$t('message.All Areas of Study')">
                                            <div class="tdcell">
                                                <a href="javascript:;" style="color: inherit">{{$t('message.All Areas of Study')}}</a>
                                            </div>
                                            <div class="tdcell width-25 text-right">
                                                <span class="check-box " :class="selectedAllAreaOfStudy?'checked':''"></span>
                                            </div>
                                        </li>

                                        <li class="item-table" ref="hexagonItem" v-for="(areaOfStudy,index) in  areaOfStudys" v-on:click="selectAreaOfStudyFn(areaOfStudy)" role="option" :aria-label="$store.getters.getContent(areaOfStudy.langMap)">
                                            <div class="tdcell">
                                            <a href="javascript:;" style="color: inherit">
																							{{$store.getters.getContent(areaOfStudy.langMap)}}
																						</a>
                                            </div>
                                            <div class="tdcell width-25 text-right">
                                                <span class="check-box"  :class="areaOfStudy.selected?'checked':''" ></span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class=" col-sm-12 " style="padding: 0 !important;" v-if="!showExtra">
                            <div class="row pad-10">
                                <div class="col-sm-12 col-xs-12" style="padding-top:5px;" >
                                    <span class="width-25 " v-on:click="checkedCefFn()">
                                        <span class="check-box" :class="isCef?'checked':''" role="checkbox" :aria-label="$t('message.CEF')"></span>
                                    </span>
                                    <span class=" pad-l-10" style="padding-top:5px;">
                                        <span class="pad-l-10" v-on:click="checkedCefFn()">
																					<a href="javascript:;" style="color: inherit">{{$t('message.CEF')}}</a>
																				</span>
                                        <i class="icon-i pad-l-10 pointer" v-on:click="getCEFInfo()"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-lg-3 moreGroup" v-if="$store.state.innerWidth>=770">
                        <div class="row">
                            <div class="col-xs-12 search-btn">
                                <div class="btn btn-primary"  v-on:click="searchEvent()" role="button" :aria-label="$t('message.Search')">
                                    <a href="javascript:;" style="color: inherit">{{$t('message.Search')}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" style="padding: 0 !important;">
                        <VueSlideToggle :open="showExtra"  :duration="500">
                            <div class="extra-criteria row" >
                                <div class="col-sm-8 col-lg-9">
                                    <div class="col-sm-6 pad-10 " :class="{'show':showLearningMode}">
                                        <div class="input-group" @click="openLearningMode" role="combobox" :aria-label="$t('message.All Learning Modes')">
                                            <b class="i-left">
                                                <i class="icon-clock gray" aria-hidden="true"></i>
                                            </b>
                                            <div class="input-two allInput ">
                                                <span  class="oneline-box"  v-if="!learningModeDisplay" >
																									<a href="javascript:;" style="color: inherit">{{$t('message.All Learning Modes')}}</a>
																								</span>
                                                <span  class="oneline-box" v-else >
																									<a href="javascript:;" style="color: inherit">{{learningModeDisplay}}</a>
																								</span>
                                            </div>
                                            <b class="i-right">
                                                <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                                            </b>
                                        </div>
                                         <div class="criteria-content multi-layer criteria-job-func show-choice experienceList" :class="{'show':showLearningMode}">
                                            <ul>
                                                <li class="item-table" v-on:click="selectAllLearningModeFn()" role="option" :aria-label="$t('message.All Learning Modes')">
                                                    <div class="tdcell">
                                                       <a href="javascript:;" style="color: inherit">{{$t('message.All Learning Modes')}}</a>
                                                    </div>
                                                    <div class="tdcell width-25 text-right">
                                                        <span class="check-box " :class="selectedAllLearningMode?'checked':''"></span>
                                                    </div>
                                                </li>

                                                <li class="item-table" v-for="(learningMode,index) in learningModes"
                                                 v-on:click="selectLearningModeFn(learningMode)" 
																								 role="option" 
																								 :aria-label="$store.getters.getContent(learningMode.langMap)"
                                                >
                                                    <!--  -->
                                                    <div class="tdcell">
                                                        <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(learningMode.langMap)}}</a>
                                                    </div>
                                                    <div class="tdcell width-25 text-right">
                                                        <span class="check-box"  :class="learningMode.selected?'checked':''" ></span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 pad-10 " :class="{'show':showGrantingBody}">
                                        <div class="input-group"  @click="openGrantingBody" role="option" :aria-label="$t('message.All Course Providers')">
                                            <b class="i-left">
                                                <i class="icon-school gray" aria-hidden="true"></i>
                                            </b>
                                            <div class="input-two allInput ">
                                                <span  class="oneline-box"  v-if="!grantingBodyDisplay" >
																									<a href="javascript:;" style="color: inherit">{{$t('message.All Course Providers')}}</a>
																								</span>
                                                <span  class="oneline-box" v-else >
																									<a href="javascript:;" style="color: inherit">{{grantingBodyDisplay}}</a>
																								</span>
                                                <!-- <input type="text" ref="schoolInput" v-model="schoolLetter" v-on:input="changeLetter()" onkeyup="value=value.replace(/[^a-zA-Z]/g,'')" > -->
                                            </div>
                                           
                                            <b class="i-right">
                                                <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                                            </b>
                                        </div>
                                        <div class="criteria-content multi-layer criteria-job-func show-choice experienceList" ref="schoolInner" :class="{'show':showGrantingBody}">
                                            <ul ref="schoolUl">
                                                 <li class="item-table" ref="schoolOneLi" v-on:click="selectAllGrantingBodyFn()" role="option" :aria-label="$t('message.All Course Providers')">
                                                    <div class="tdcell">
                                                        <a href="javascript:;" style="color: inherit">{{$t('message.All Course Providers')}}</a>
                                                    </div>
                                                    <div class="tdcell width-25 text-right">
                                                        <span class="check-box " :class="selectAllGrantingBody?'checked':''"></span>
                                                    </div>
                                                </li>

                                                <li
																									class="item-table"
																									ref="schoolItem"
																									v-for="(grantingBody,index) in $store.getters.getContent(grantingBodys)" 
																									v-on:click="selectGrantingBodyFn(grantingBody)"
																									role="option"
																									:aria-label="grantingBody.name | capitalize"
																								>
                                                    <!--  -->
                                                    <div class="tdcell">
                                                      <a href="javascript:;" style="color: inherit">{{grantingBody.name | capitalize}}</a>
                                                    </div>
                                                    <div class="tdcell width-25 text-right">
                                                        <span class="check-box"  :class="grantingBody.selected?'checked':''" ></span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 pad-10 " :class="{'show':showLevel}">
                                        <div class="input-group"  @click="openLevel" role="combobox" :aria-label="$t('message.All Level')">
                                            <b class="i-left">
                                                <i class="icon-level gray" aria-hidden="true"></i>
                                            </b>
                                            <div class="input-two allInput ">
                                                <span  class="oneline-box"  v-if="!levelDisplay" >
																									<a href="javascript:;" style="color: inherit">{{$t('message.All Level')}}</a>
																								</span>
                                                <span  class="oneline-box" v-else >
																									<a href="javascript:;" style="color: inherit">{{levelDisplay}}</a>
																								</span>
                                            </div>
                                            <b class="i-right">
                                                <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                                            </b>
                                        </div>
                                        <div class="criteria-content multi-layer criteria-job-func show-choice experienceList" :class="{'show':showLevel}">
                                            <ul>
                                                 <li class="item-table" v-on:click="selectAllLevelFn()" role="option" :aria-label="$t('message.All Level')">
                                                    <div class="tdcell">
                                                        <a href="javascript:;" style="color: inherit">{{$t('message.All Level')}}</a>
                                                    </div>
                                                    <div class="tdcell width-25 text-right">
                                                        <span class="check-box " :class="selectAllLevel?'checked':''"></span>
                                                    </div>
                                                </li>

                                                <li class="item-table" v-for="(level,index) in levelList" v-on:click="selectLevelFn(level)" role="option" :aria-label="$store.getters.getObject(level.langMap).title | capitalize">
                                                    <!--  -->
                                                    <div class="tdcell">
                                                        <a href="javascript:;" style="color: inherit">{{$store.getters.getObject(level.langMap).title | capitalize}}</a>
                                                    </div>
                                                    <div class="tdcell width-25 text-right">
                                                        <span class="check-box"  :class="level.selected?'checked':''" ></span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col-sm-12 ">
                                    <div class="row pad-10 ">
                                        <div class="col-sm-4 " style="padding-top:10px;"  :class="{'col-xs-12':$store.state.innerWidth<=768}">
                                            <div class="">
                                                <span class="width-25 tdcell" v-on:click="checkedCefFn()">
                                                    <span class="check-box" role="checkbox" :aria-label="$t('message.CEF')" :class="isCef?'checked':''"></span>
                                                </span>
                                                <span class=" tdcell pad-l-10" :class="{'pad-l-20':$store.state.innerWidth>768}">
                                                    <span class="" v-on:click="checkedCefFn()" >
																											<a href="javascript:;" style="color: inherit">{{$t('message.CEF')}}</a>
																										</span>
                                                    <i class="icon-i pad-l-10 pointer" v-on:click="getCEFInfo()" ></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4  "  style="padding-top:10px;"  :class="{'col-xs-12':$store.state.innerWidth<=768}">
                                            <div class="">
                                                <span class="width-25 tdcell"  v-on:click="checkedQrFn()">
                                                  <span class="check-box" role="checkbox" :aria-label="$t('message.QR Courses')" :class="isQr?'checked':''"></span>
                                                </span>
                                                <span class="tdcell pad-l-10"   :class="{'pad-l-20':$store.state.innerWidth>768}">
                                                    <span class="" v-on:click="checkedQrFn()">
																											<a href="javascript:;" style="color: inherit">{{$t('message.QR Courses')}}</a>
																										</span>
                                                    <i class="icon-i pad-l-10 pointer" v-on:click="getQRInfo()"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 "  style="padding-top:10px;"  :class="{'col-xs-12':$store.state.innerWidth<=768}">
                                            <div class="">
                                                <span class="width-25 tdcell" v-on:click="checkedEdxFn()">
                                                    <span class="check-box" role="checkbox" :aria-label="$t('message.MOOC Courses')" :class="isEdx?'checked':''"></span>
                                                </span>
                                                <span class=" tdcell pad-l-10"  :class="{'pad-l-20':$store.state.innerWidth>768}">
                                                    <span class="" v-on:click="checkedEdxFn()">
																											<a href="javascript:;" style="color: inherit">{{$t('message.MOOC Courses')}}</a>
																										</span>
                                                    <i class="icon-i pad-l-10 pointer" v-on:click="getMOOCInfo()"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </VueSlideToggle>
                    </div>
                    <div class="col-sm-12  more-options moreOptions SemiBold" v-if="needOptions&&$store.state.innerWidth<=768">
                        <span class="moreOptions"  v-if="!showExtra">
                            <span class="pointer" @click="moreEvent">{{$t('message.More Options')}}</span>
                        </span>
                        <span class="moreOptions" @click="moreEvent" v-if="showExtra">
                            
                            <span class="pointer" @click="moreEvent">{{$t('message.Fewer Options')}}</span>
                        </span>
                    </div>
                    <!-- <div class="col-sm-4 col-lg-3 moreGroup" v-if="$store.state.innerWidth>=770">
                        <div class="row">
                            <div class="col-xs-12 search-btn">
                                <div class="btn btn-primary"  v-on:click="searchEvent()">
                                    {{$t('message.Search')}}
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-sm-12  more-options moreOptions SemiBold" v-if="needOptions&&$store.state.innerWidth>768">
                        <span class="moreOptions"  v-if="!showExtra">
                            <span class="pointer" @click="moreEvent">
															<a href="javascript:;" style="color: inherit">{{$t('message.More Options')}}</a>
														</span>
                        </span>
                        <span class="moreOptions"  v-if="showExtra">
                            <span class="pointer" @click="moreEvent">
															<a href="javascript:;" style="color: inherit">{{$t('message.Fewer Options')}}</a>
														</span>
                        </span>
                    </div>

										<!-- instant-filter -->
										<div class="instant-filter pad-10">
											<label class="filter-label">
												{{ $t("message.Instant-filter") }}
											</label>
											<div class="filter-group">
												<div class="filter-btn" v-for="(filter, index) in filterList" :key="index">
													<button :class="{ 'filterActive': instantActive == `courseFilter${filter.key}` }" @click="instantFilter(`courseFilter${filter.key}`, filter.key)">
														<a href="javascript:;" style="color: inherit">{{ $store.getters.getContent(filter.langMap) }}</a>
													</button>
												</div>
											</div>
										</div>
										
										<div class="col-sm-4 col-lg-3 moreGroup" v-if="$store.state.innerWidth < 770">
											<div class="row">
												<div class="col-xs-12 col-md-12 search-btn pad-10">
													<div class="btn btn-primary" v-on:click="searchEvent()" role="button" :aria-label='$t("message.Search")'>
														{{ $t("message.Search") }}
													</div>
												</div>
											</div>
										</div>

                </div>
            </div>
        </div>
        <div class="mask" @click="closePopup"  :class="{'show':(showAreaOfStudy||showLearningMode||showGrantingBody||showLevel),'maskPC':$store.state.innerWidth>768}"></div>
    </div>
</template>
<script>
import { VueSlideToggle } from 'vue-slide-toggle'
import { EventBus } from "@/javascripts/eventBus.js";
export default {
    data() {
        return {
           
            isMobile:false,
            showExtra:false,
            showAreaOfStudy: false,
            areaOfStudys:[],
            selectedAllAreaOfStudy:false,

            grantingBodys:[],
            showGrantingBody:false,
            showLevel:false,
            selectAllGrantingBody:false,

            learningModes:[],
            showLearningMode:false,
            selectedAllLearningMode:false,

            isCef:false,
            isQr:false,
            isEdx:false,

            keyword:"",

            areaOfStudyDisplay:"",
            areaOfStudyData:[],
            learningModeDisplay:"",
            learningModeData:[],
            grantingBodyDisplay:"",
            grantingBodyData:[],

            selectAllLevel:false,
            levelDisplay:"",
            levelData:[],
            levelList:[],
            schoolLetter:'',
            schoolInnerScroll:0,
            hexagonInnerScroll:0,
						// selectedAllAreaOfStudys
						
						filterList: [],
						courseQuickQuery: "",
						instantActive: "",
        }
    },
    props: {
        needOptions: true,
        search:{},
				childLogGaEvent:null,
				filterActive: {},
    },

    components: {
       VueSlideToggle
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    methods: {
        scrollHexagon:function(){
            var that = this;
            var sr
            that.hexagonInnerScroll = that.$refs.hexagonOneLi.clientHeight + 10;
            for(var i=0;i<that.$refs.hexagonItem.length;i++){
            
                if(that.$refs.hexagonItem[i].innerText.substr(0, 1).toLowerCase() == that.schoolLetter.toLowerCase()){
                    
                    break;
                }else{
                    that.hexagonInnerScroll = that.$refs.hexagonItem[i].clientHeight + that.hexagonInnerScroll;
                }
            }
            sr = (that.$refs.hexagonInner.scrollHeight/that.$refs.hexagonUl.clientHeight)*that.hexagonInnerScroll;
            that.$refs.hexagonInner.scrollTo(0,sr)
        },
        scrollSchool:function(){
            var that = this;
            var sr
            that.schoolInnerScroll = that.$refs.schoolOneLi.clientHeight + 10;
            for(var i=0;i<that.$refs.schoolItem.length;i++){
                
                if(that.$refs.schoolItem[i].innerText.substr(0, 1).toLowerCase() == that.schoolLetter.toLowerCase()){
                 
                    break;
                }else{
                    that.schoolInnerScroll = that.$refs.schoolItem[i].clientHeight + that.schoolInnerScroll;
                }
            }
    
           
            sr = (that.$refs.schoolInner.scrollHeight/that.$refs.schoolUl.clientHeight)*that.schoolInnerScroll;
            that.$refs.schoolInner.scrollTo(0,sr)
        
        },
        changeLetter:function(){
            // console.log(this.schoolLetter)
            
            if(this.schoolLetter.replace(/[^a-zA-Z]/g,'') !=''){
                // console.log(this.schoolLetter.substr(this.schoolLetter.length-1,1));
                this.schoolLetter = this.schoolLetter.substr(this.schoolLetter.length-1,1);
                
            }
            
        },
        openAreaOfStudy:function(){
            this.closeAllDropdownFn("openAreaOfStudy")
            this.showAreaOfStudy = !this.showAreaOfStudy;
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'openAreaOfStudy')
            if(this.comment.getType()){
                this.isMobile = true;
            }
        },
        moreEvent:function(){
            this.showExtra = !this.showExtra;
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'More option')
        },
        getAreaOfStudy:function(){
            let that=this
            this.api.getAreaOfStudy({ }, function(data) {
                for(var i=0;i<data.result.length;i++){

                    // data.result[i].content = data.result[i].content.map(function(v,i){

                    //     let obj={}
                    //     obj.name=v;
                        data.result[i].selected=false
                    //     return obj
                    // })
                }
                that.areaOfStudys = data.result;
            })
        },
        selectAreaOfStudyFn:function(obj){
            obj.selected=!obj.selected
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'selectAreaOfStudy')
        },
        selectAllAreaOfStudyFn:function(obj){
            let that=this
            this.selectedAllAreaOfStudy=!this.selectedAllAreaOfStudy;
            for(var i=0;i<this.areaOfStudys.length;i++){
                // this.areaOfStudys[i] = this.areaOfStudys[i].content.map(function(v,i){
                    this.areaOfStudys[i].selected=that.selectedAllAreaOfStudy
                //     return v
                // })
            }
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'selectAllAreaOfStud')
        },
        getGrantingBody:function(){
            let that=this
            this.api.getGrantingBody({ }, function(data) {
                // 
                for(var i=0;i<data.result.length;i++){
                    data.result[i].content = data.result[i].content.map(function(v,i){
                        let obj={}
                        obj.name=v;
                        obj.selected=false
                        return obj
                    })
                }
                that.grantingBodys = data.result;
            })
        },
        openGrantingBody:function(){
            // this.$refs.schoolInput.focus();
            this.closeAllDropdownFn("openGrantingBody")
            this.showGrantingBody = !this.showGrantingBody;
            if(this.comment.getType()){
                this.isMobile = true;
            }
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'openGrantingBody')
        },
        selectGrantingBodyFn:function(obj){
            obj.selected=!obj.selected
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'selectGrantingBody')
        },
        selectAllGrantingBodyFn:function(){
            // 
            let that=this
            this.selectAllGrantingBody=!this.selectAllGrantingBody

            for(var i=0;i<this.grantingBodys.length;i++){
                this.grantingBodys[i].content = this.grantingBodys[i].content.map(function(v,i){
                    v.selected=that.selectAllGrantingBody
                    return v
                })
            }
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'selectAllGrantingBody')
        },
        selectAllLevelFn:function(){
            // 
            let that=this
            this.selectAllLevel=!this.selectAllLevel
            this.levelList = this.levelList.map(function(v,i){
                v.selected=that.selectAllLevel
                return v
            })
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'selectAllLevel')
        },
        openLevel:function(){
            this.closeAllDropdownFn("openLevel");
             this.showLevel = !this.showLevel;
            if(this.comment.getType()){
                this.isMobile = true;
            }
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'openLevel')
        },
        getCourseLevelList:function(){
            let that=this
            this.api.getCourseLevelList({ }, function(data) {
                that.levelList = data.result.map(function(v,i){
                    v.selected=false
                    return v
                })
            })
        },
        selectLevelFn:function(obj){
            obj.selected=!obj.selected
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'selectLevel')
        },
        getLearningMode:function(){
            let that=this
            this.api.getLearningMode({ }, function(data) {
                // 
                that.learningModes = data.result.map(function(v,i){
                    v.selected=false
                    return v
                })
                // 
            })
        },
        openLearningMode:function(){
            this.closeAllDropdownFn("openLearningMode")
            this.showLearningMode = !this.showLearningMode;
            if(this.comment.getType()){
                this.isMobile = true;
            }
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'openLearningMode')
        },
        selectLearningModeFn:function(obj){
            obj.selected=!obj.selected
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'selectLearningMode')
        },
        selectAllLearningModeFn:function(){
            let that=this
            this.selectedAllLearningMode=!this.selectedAllLearningMode


            this.learningModes.map(function(v,i){
                v.selected=that.selectedAllLearningMode
                return v
            })
            this.childLogGaEvent('userClick',  'browseCourseSearch',    'selectAllLearningMode')
        },
        closeAllDropdownFn:function(mode){
            if(mode!="openAreaOfStudy")
                this.showAreaOfStudy= false
            if(mode!="openGrantingBody")
                this.showGrantingBody=false
            if(mode!="openLearningMode")
                this.showLearningMode=false
            if(mode!="openLevel")
                this.showLevel=false
        },
        checkedCefFn:function(){
            this.isCef=!this.isCef;
        },
        checkedQrFn:function(){
            this.isQr=!this.isQr;
        },
        checkedEdxFn:function(){
            this.isEdx=!this.isEdx;
        },
        searchEvent: function() {
            var that = this;
            // debugger
            if(this.$route.name=="home"){
                this.$router.push({
                    path:'/findAnOpportunity',
                    query:{lang:this.$store.state.language}
                })
            }else{
                // 

                this.childLogGaEvent('search',  'browseCourseSearch',    that.keyword)
                let dataSource="";
                if(this.isQr&&!this.isEdx){
                    dataSource="qr"
                }else if(!this.isQr&&this.isEdx){
                    dataSource="edx"
                }else{
                    dataSource=""
                }
                let Base64 = require('js-base64').Base64
                let postData={}
                // if(that.keyword){
                    postData.keyword=Base64.encode(that.keyword)
                // }
                if(that.areaOfStudyData.length&&!that.selectedAllAreaOfStudy){
                    postData.areaOfStudy=Base64.encode(JSON.stringify(that.areaOfStudysEvent()))
                }else{
                    postData.areaOfStudy = "";
                }
                if(that.learningModeData.length&&!that.selectedAllLearningMode){
                    postData.learningMode=Base64.encode(JSON.stringify(that.learningModeData))
                }else{
                    postData.learningMode = "";
                }
                if(that.grantingBodyData.length&&!that.selectAllGrantingBody){
                    postData.grantingBody=Base64.encode(JSON.stringify(that.grantingBodysEvent()))
                }else{
                    postData.grantingBody = "";
                }
                if(that.levelData.length&&!that.selectAllLevel){
                    postData.courseLevel=Base64.encode(JSON.stringify(that.levelData))
                }else{
                    postData.courseLevel = "";
                }
                // if(dataSource){
                    postData.dataSource=dataSource;
								// }
								postData.courseQuickQuery = that.courseQuickQuery;
								postData.isCef=that.isCef?"true":"";
								postData.isQr=that.isQr?"true":"";
                this.search(postData)
            }
            
        },
        clearEvent:function(){
            this.keyword = "";
        },
        closePopup:function(){
           
            this.showAreaOfStudy = false;
            this.showLearningMode = false;
            this.showGrantingBody = false;
            this.showLevel = false;
        },
        grantingBodysEvent:function(){
            if(this.grantingBodys.length==0) return [];
            let that=this;
            let selectedGrantingBodys=that.$store.getters.getContent(that.grantingBodys).filter(grantingBody=>grantingBody.selected)
            this.selectAllGrantingBody=(selectedGrantingBodys.length==that.$store.getters.getContent(that.grantingBodys).length)
            if(that.selectAllGrantingBody){
                this.grantingBodyDisplay=this.$i18n.t("message.All Course Providers");
                // this.grantingBodyData = []
            }else{
                this.grantingBodyDisplay=selectedGrantingBodys.map(
                    function(v,i){return v.name}
                ).join(',')
            }
                this.grantingBodyData=selectedGrantingBodys.map(function(v,i){return v.name});
            
            return this.grantingBodyData;
        },
        areaOfStudysEvent:function(){
            if(this.areaOfStudys.length==0) return [];
            let that=this
            let selectedAreaOfStudys=that.areaOfStudys.filter(areaOfStudy=>areaOfStudy.selected)
            this.selectedAllAreaOfStudy=(selectedAreaOfStudys.length==this.areaOfStudys.length)
            if(that.selectedAllAreaOfStudy){
                this.areaOfStudyDisplay= this.$i18n.t("message.All Areas of Study");
                // var data =[]
            }else{
                this.areaOfStudyDisplay=selectedAreaOfStudys.map(
                    function(v,i){return that.$store.getters.getContent(v.langMap)}
                ).join(',')
            }
                this.areaOfStudyData=selectedAreaOfStudys.map(function(v,i){return v.key}).join(',')
                var data = this.areaOfStudyData.split(',')
            return data;
        },
        getCEFInfo:function(){
            var link = "<a  class='info-link mainColor ' href='"+this.$i18n.t("message.CEF_link")+"' target='_blank'>"+this.$i18n.t("message.CEF_link_text")+"</a>";
          
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.CEF_text")+"</div></div>"
            text = text.replace('[link]', link);
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.CEF")})
        },
        getQRInfo:function(){
            var link = "<a  class='info-link mainColor ' href='"+this.$i18n.t("message.QR_link")+"' target='_blank'>"+this.$i18n.t("message.QR_link_text")+"</a>";
          
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.QR_text")+"</div></div>"
            text = text.replace('[link]', link);
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.QR Courses")})
        },
        getMOOCInfo:function(){
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.MOOC_text")+"</div></div>"
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.MOOC Courses")})
				},
				geCourseQuickQuery: function() {
					let that=this
          this.api.geCourseQuickQuery({ }, function(data) {
						that.filterList = data.result
          })
				},
				instantFilter: function(filter, id) {
					if( this.instantActive == filter) {
						this.instantActive = "";
						this.courseQuickQuery = "";
					} else {
						this.instantActive = filter;
						this.courseQuickQuery = id;
					}

					this.searchEvent();
				},

    },
    mounted() {
        var that = this;
        this.getAreaOfStudy();
        this.getGrantingBody();
        this.getLearningMode();
        this.getCourseLevelList();
        this.geCourseQuickQuery();
        document.addEventListener('keydown', function (e) {
            var keyNum
            if(e.keyCode==65||e.keyCode==66||e.keyCode==67||e.keyCode==68||e.keyCode==69||e.keyCode==70||e.keyCode==71||e.keyCode==72||e.keyCode==73||e.keyCode==74||e.keyCode==75||e.keyCode==76||e.keyCode==77||e.keyCode==78||e.keyCode==79||e.keyCode==80||e.keyCode==81||e.keyCode==82||e.keyCode==83||e.keyCode==84||e.keyCode==85||e.keyCode==86||e.keyCode==87||e.keyCode==88||e.keyCode==89||e.keyCode==90){
                e.keyCode==65?keyNum = 'a':'';
                e.keyCode==66?keyNum = 'b':'';
                e.keyCode==67?keyNum = 'c':'';
                e.keyCode==68?keyNum = 'd':'';
                e.keyCode==69?keyNum = 'e':'';
                e.keyCode==70?keyNum = 'f':'';
                e.keyCode==71?keyNum = 'g':'';
                e.keyCode==72?keyNum = 'h':'';
                e.keyCode==73?keyNum = 'i':'';
                e.keyCode==74?keyNum = 'j':'';
                e.keyCode==75?keyNum = 'k':'';
                e.keyCode==76?keyNum = 'l':'';
                e.keyCode==77?keyNum = 'm':'';
                e.keyCode==78?keyNum = 'n':'';
                e.keyCode==79?keyNum = 'o':'';
                e.keyCode==80?keyNum = 'p':'';
                e.keyCode==81?keyNum = 'q':'';
                e.keyCode==82?keyNum = 'r':'';
                e.keyCode==83?keyNum = 's':'';
                e.keyCode==84?keyNum = 't':'';
                e.keyCode==85?keyNum = 'u':'';
                e.keyCode==86?keyNum = 'v':'';
                e.keyCode==87?keyNum = 'w':'';
                e.keyCode==88?keyNum = 'x':'';
                e.keyCode==89?keyNum = 'y':'';
                e.keyCode==90?keyNum = 'z':'';
            }
            that.schoolLetter = keyNum;
            if(that.showGrantingBody){
                that.scrollSchool();
            }else if(that.showAreaOfStudy){
                that.scrollHexagon();
            }
            
          
        });
    },
    computed:{
        _language(){
          return this.$store.state.language
        }
    },
    //   beforeRouteLeave(to, from, next){ 
        
    //     if(from.name=='occupationDetails'){
    //         var that = this;
    //         new Promise((resolve,reject)=>{
    //             that.isCef = false;
    //             that.isQr = false;
    //             that.isEdx = false;
    //             that.showExtra = false;
    //             that.getAreaOfStudy();
    //             that.getGrantingBody();
    //             that.getLearningMode();
    //             that.getCourseLevelList();
    //             resolve();
    //         }).then((data)=>{
    //             this.searchEvent();
    //         })
          
          
    //     }else{
    //       this.searchEvent();
    //     }
    //     next()
    // },
    watch: {
     '$route.params.keyword': {
        handler: function(v,o) {
            // 
            if(v!=0){
                if(this.$route.params.keyword){
                    this.keyword=this.$route.params.keyword;
                    var that = this;
                    setTimeout(function(){
                        if(that.$parent.fromLouterName != 'coursesDetail'){
                            that.searchEvent()
                        }
                    })
                    
                }
            }
            
        },
        deep: true,
        immediate: true
      },
        learningModes: {
            handler: function(val, oldval) {
                let that=this
                let selectedLearningModes=that.learningModes.filter(learningMode=>learningMode.selected)
                this.selectedAllLearningMode=(selectedLearningModes.length==this.learningModes.length)
                if(that.selectedAllLearningMode){
                    this.learningModeDisplay= this.$i18n.t("message.All Learning Modes");
                    // this.learningModeData=[]
                }else{
                    this.learningModeDisplay=selectedLearningModes.map(
                        function(v,i){
                            return that.$store.getters.getContent(v.langMap)
                        }
                    ).join(',')
                    
                }
                this.learningModeData=selectedLearningModes.map(function(v,i){return v.key})
                // this.learningModeData=selectedLearningModes.map(function(v,i){return v.key})

            },
            deep: true
        },
        areaOfStudys: {
            handler: function(val, oldval) {
                    let that=this
                    let selectedAreaOfStudys=that.areaOfStudys.filter(areaOfStudy=>areaOfStudy.selected)
                    this.selectedAllAreaOfStudy=(selectedAreaOfStudys.length==this.areaOfStudys.length)
                    if(that.selectedAllAreaOfStudy){
                        this.areaOfStudyDisplay= this.$i18n.t("message.All Areas of Study")
                    }else{
                        this.areaOfStudyDisplay=selectedAreaOfStudys.map(
                            function(v,i){
                                return that.$store.getters.getContent(v.langMap)
                            }
                        ).join(',')
                    }
                    this.areaOfStudyData=selectedAreaOfStudys.map(function(v,i){return v.key})

            },
            deep: true
        },
        grantingBodys: {
            handler: function(val, oldval) {
                let that=this
                let selectedGrantingBodys=that.$store.getters.getContent(that.grantingBodys).filter(grantingBody=>grantingBody.selected)
                this.selectAllGrantingBody=(selectedGrantingBodys.length==that.$store.getters.getContent(that.grantingBodys).length)
                if(that.selectAllGrantingBody){
                    this.grantingBodyDisplay= this.$i18n.t("message.All Course Providers")
                }else{
                    this.grantingBodyDisplay=selectedGrantingBodys.map(
                        function(v,i){return v.name}
                    ).join(',')
                }
                this.grantingBodyData=selectedGrantingBodys.map(function(v,i){return v.name})
            },
            deep: true
        },
        _language:{
            handler: function(val, oldVal) {
                let that=this
                if(that.grantingBodys.length){
                    let selectedGrantingBodys=that.$store.getters.getContent(that.grantingBodys).filter(grantingBody=>grantingBody.selected)
                    this.selectAllGrantingBody=(selectedGrantingBodys.length==that.$store.getters.getContent(that.grantingBodys).length)
                    if(this.selectAllGrantingBody){
                        this.grantingBodyDisplay= this.$i18n.t("message.All Course Providers")
                    }else{
                        this.grantingBodyDisplay=selectedGrantingBodys.map(
                            function(v,i){return v.name}
                        ).join(',')
                    }
                }
                let selectedAreaOfStudys=that.areaOfStudys.filter(areaOfStudy=>areaOfStudy.selected)
                this.selectedAllAreaOfStudy=(selectedAreaOfStudys.length==this.areaOfStudys.length)
                if(this.selectedAllAreaOfStudy){
                    this.areaOfStudyDisplay= this.$i18n.t("message.All Areas of Study")
                }else{
                    this.areaOfStudyDisplay=selectedAreaOfStudys.map(
                        function(v,i){
                            return that.$store.getters.getContent(v.langMap)
                        }
                    ).join(',')
                }
                let selectedLearningModes=that.learningModes.filter(learningMode=>learningMode.selected)
                this.selectedAllLearningMode=(selectedLearningModes.length==this.learningModes.length)
                if(this.selectedAllLearningMode){
                    this.learningModeDisplay= this.$i18n.t("message.All Learning Modes")
                }else{
                    this.learningModeDisplay=selectedLearningModes.map(
                        function(v,i){
                            return that.$store.getters.getContent(v.langMap)
                        }
                    ).join(',')
                    
                }
                let selectedLevel=that.levelList.filter(level=>level.selected)
                this.selectAllLevel=(selectedLevel.length==this.levelList.length)
                if(this.selectAllLevel){
                    this.levelDisplay= this.$i18n.t("message.All Level")
                }else{
                    this.levelDisplay=selectedLevel.map(
                        function(v,i){
                            return that.$store.getters.getObject(v.langMap).title
                        }
                    ).join(',')
                }
            },
            deep: true
        },
        levelList: {
            handler: function(val, oldval) {
                    let that=this
                    let selectedLevel=that.levelList.filter(level=>level.selected)
                    this.selectAllLevel=(selectedLevel.length==this.levelList.length)
                    if(that.selectAllLevel){
                        this.levelDisplay= this.$i18n.t("message.All Level")
                    }else{
                        this.levelDisplay=selectedLevel.map(
                            function(v,i){
                                return that.$store.getters.getObject(v.langMap).title
                            }
                        ).join(',')
                    }
                    var data = selectedLevel.map(function(v,i){return v.key}).join(',')
                    if(data){
                        this.levelData=data.split(',');
                    }else{
                        this.levelData = ""
                    }
            },
            deep: true
				},
				filterActive: {
					handler: function(val, oldVal){
						this.instantActive = "";
						this.courseQuickQuery = "";
					},
					deep: true,
				},
    }
}
</script>